var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`silkSprite-${_vm.tabNo} harness`,style:(`background-image: url('http://d36frgpkvm82k8.cloudfront.net/${_vm.externalMeetingId}_${_vm.raceNumber}_SPRITE_32x32.png')`)})
}
var staticRenderFns = []

export { render, staticRenderFns }